import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon5 from '../ReactIcons/icon5';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon5 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon5 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon5;